<div class="unit" *ngIf="formatting.prefix" [style.max-width]="maxFormattingUnitWidth" [uiTooltipTitle]="formatting.prefix" tooltipIfOverflow="hover" uiTooltipPlacement="bottom" ui-tooltip>
  {{ formatting.prefix }}
</div>
<div class="value">{{ formattedValue }}</div>
<div class="unit" *ngIf="formatting.suffix" [style.max-width]="maxFormattingUnitWidth" [uiTooltipTitle]="formatting.suffix" tooltipIfOverflow="hover" uiTooltipPlacement="bottom" ui-tooltip>
  {{ formatting.suffix }}
</div>
